export default {
  items: [
    {
      active: [1,2,3],
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      active: [1],
      name: 'Users',
      icon: 'icon-star',
      children: [
        {
          active: [1],
          name: 'Add User',
          url: '/add-user',
          icon: 'icon-puzzle'
        },
        {
          active: [1],
          name: 'User List',
          url: '/users',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      active: [1,2,3],
      name: 'Orders',
      url: '/orders',
      icon: 'icon-star'
    },
    {
      active: [1],
      name: 'Brands',
      url: '/brands',
      icon: 'icon-star',
      children: [
        {
          active: [1],
          name: 'Brand List',
          url: '/brands',
          icon: 'icon-puzzle'
        },
        {
          active: [1],
          name: 'Add Brand',
          url: '/add-brand',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      active: [1],
      name: 'Categories',
      url: '/categories',
      icon: 'icon-star',
      children: [
        {
          active: [1],
          name: 'Category List',
          url: '/categories',
          icon: 'icon-puzzle'
        },
        {
          active: [1],
          name: 'Add Category',
          url: '/add-category',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      active: [1],
      name: 'Products',
      url: '/products',
      icon: 'icon-star',
      children: [
        {
          active: [1],
          name: 'Product List',
          url: '/products',
          icon: 'icon-puzzle'
        },
        {
          active: [1],
          name: 'Add Product',
          url: '/add-product',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      active: [1,2],
      name: 'Shop Inventories',
      url: '/inventory',
      icon: 'icon-star'
    },
    {
      active: [1],
      name: 'Locations',
      url: '/locations',
      icon: 'icon-star',
      children: [
        {
          active: [1],
          name: 'Delivery Locations',
          url: '/locations',
          icon: 'icon-puzzle'
        },
        {
          active: [1],
          name: 'Add Location',
          url: '/add-location',
          icon: 'icon-puzzle'
        },
        {
          active: [1],
          name: 'Assign Location',
          url: '/assign',
          icon: 'icon-puzzle'
        },
        {
          active: [1],
          name: 'Maps',
          url: '/maps',
          icon: 'icon-puzzle'
        }
      ]
    },
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js